<script>
  import { page } from '@inertiajs/svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let item;

  let grow = false;
</script>

<article
  class="related-mob-item"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  <div class="related-mob-item__image">
    {#if item.image.src}
      <img
        src={item.image.src}
        width={item.image.width}
        height={item.image.height}
        alt={item.image.alt}
        loading="lazy"
      />
    {/if}
  </div>
  <div class="related-mob-item__logo">
    {#if item.logo.src}
      <img
        src={item.logo.src}
        width={item.image.width}
        height={item.image.height}
        alt={item.logo.alt}
        loading="lazy"
      />
    {/if}
  </div>

  <div class="related-mob-item__content">
    <div class="related-mob-item__title-wrap">
      <p class="tagline related-mob-item__title">{item.title}</p>
      {#if item.cat}
        <p class="text-small related-mob-item__cat">{item.cat}</p>
      {/if}
    </div>

    <div class="related-mob-item__more">
      <a class="btn btn-icon btn-more btn-more--light" href={item.url}>
        <span>Learn more</span>
        <i class="isax isax-arrow-right-1" />
      </a>
    </div>
  </div>
</article>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .related-mob-item {
    position: relative;
    overflow: hidden;
    height: 44rem;
    border-radius: 2rem;

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    &__image {
      z-index: 0;
      position: relative;

      width: 100%;
      height: 100%;

      background-color: rgb(var(--black));

      &::after,
      &::before {
        content: '';
        position: absolute;
        inset: 0;
      }

      &::after {
        z-index: 1;
        background: url(img/noise.png) 300px 300px;
      }

      &::before {
        @include gradient('grey', 'to top');

        z-index: 2;
        opacity: 0.8;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;

        transition: all 0.3s;
      }
    }

    &__logo {
      position: absolute;
      z-index: 1;
      inset: 0;

      display: flex;
      align-items: center;
      justify-content: center;

      transition: opacity 0.3s;

      img {
        max-height: 10rem;
        max-width: calc(100% - 6rem);
      }
    }

    &__content {
      padding: 0 0 4rem;

      position: absolute;
      z-index: 1;
      inset: 0;

      color: rgb(var(--white));

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;

      text-align: center;

      transition: opacity 0.3s;
    }

    &__title-wrap {
      padding: 0 7.6rem;
    }

    &__title {
      margin-bottom: 0.5rem;
    }

    &__cat {
      color: var(--grey);
    }

    &__desc {
      padding: 0 3rem;
      margin-top: 2rem;
    }

    &__more {
      margin-top: 2rem;
    }
  }
</style>
